<script setup lang="ts">
const queryClient = useQueryClient();
await queryClient.ensureQueryData(productsQueryOptions({ slugs: ['generhvervelse'] }));
const { getBySlug } = useProducts({ slugs: ['generhvervelse'] });
const product = computed(() => getBySlug('generhvervelse'));
useSeo({ title: computed(() => product.value?.heading?.value ?? '') });

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: 'Forside', item: '/' },
      { name: 'Kørekort', item: '/kørekort' },
      { name: computed(() => product.value?.heading?.value ?? 'Generhvervelse') },
    ],
  }),
  defineCourse({
    name: computed(() => product.value?.heading?.value ?? ''),
    description: computed(() => product.value?.description?.value ? stripHtml(product.value.description.value) : ''),
    inLanguage: 'da',
    provider: { '@id': '#identity' },
  }),
]);
</script>

<template>
  <ProductContainer
    v-if="product"
    :product="product.product"
  >
    <template #illustration>
      <IconsCategoryGenerhvervelse />
    </template>
    <LazyVisibleContactForm
      subject="Tilmelding - Generhvervelse"
      is-signup
      hydrate-on-visible
    />
  </ProductContainer>
</template>
